var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, html, LitElement } from 'lit-element';
import i18n from 'roddeh-i18n';
import './wishlist-button';
import './product-modal';
import { openModal } from '../helpers/modal';
import Cart from '../services/cart';
let ProductTile = class ProductTile extends LitElement {
    constructor() {
        super(...arguments);
        this.product = null;
        this.colorAsProduct = false;
        this.stickersDisabled = false;
        this.productAsGiftButtonText = null;
        this.altshopID = '1';
    }
    connectedCallback() {
        super.connectedCallback();
        this.checkPromotions();
        Cart.addListener((event) => {
            if (event.name === 'promotionsChanged') {
                this.checkPromotions();
            }
        });
    }
    render() {
        let discountPercentage = 0;
        if (this.product !== null && this.product.price !== this.product.catalog_price) {
            discountPercentage = Math.ceil(100 - (this.product.price / this.product.catalog_price) * 100);
        }
        let cssJsMinHash = null;
        if (typeof window.__STATE__ !== 'undefined') {
            cssJsMinHash = window.__STATE__.system.css_js_min_hash;
        }
        return html `
            <link rel="stylesheet" href="/css/layout/product-tile.css${cssJsMinHash ? '?t=' + cssJsMinHash : ''}" />
            <style>
                .prod-tile {
                    height: 100%;
                    box-sizing: border-box;
                }
                .prod-as-gift.show {
                    display: flex !important;
                }
            </style>

            ${this.product !== null
            ? html `
                      <div class="prod-tile" itemscope itemtype="http://schema.org/Product">
                          <a href="${this.product.navigation.alternate_url}">
                              ${this.product.product_sticker && !this.stickersDisabled
                ? html `
                                        <div class="product-custom-sticker">
                                            <img src="${this.product.product_sticker}" />
                                        </div>
                                    `
                : html ``}
                              <img
                                  src="${this.getImageUrl(this.product, '184x184')}"
                                  width="184"
                                  height="184"
                                  alt="${this.product.name}"
                              />
                              <meta itemprop="image" content="${this.getImageUrl(this.product, '500x500')}" />
                          </a>

                          ${this.wishlistEnabled
                ? html `
                                    <wishlist-button
                                        sku="${this.sku ?? ''}"
                                        altshop_id="${this.altshopID ?? ''}"
                                    ></wishlist-button>
                                `
                : ''}
                          ${this.product.flags.bestseller || this.product.flags.new
                ? html `
                                    <div class="badge">
                                        ${this.product.flags.bestseller
                    ? i18n('Bestseller')
                    : this.product.flags.new
                        ? i18n('New')
                        : ''}
                                    </div>
                                `
                : ''}

                          <h3>
                              <a href="${this.product.navigation.alternate_url}">
                                  <span itemprop="name">
                                      ${this.product.name}
                                      ${this.product.count_attributes > 0 && this.colorAsProduct
                ? `- ${this.activeColorName}`
                : ''}
                                  </span>
                              </a>
                          </h3>

                          <meta itemprop="wrapperId" content="${this.product.id}" />
                          <meta itemprop="brand" content="Yves Rocher" />
                          <meta itemprop="sku" content="${this.sku ?? ''}" />
                          <meta itemprop="url" content="${this.product.navigation.alternate_url}" />
                          <meta itemprop="description" content="${this.product.short_description}" />

                          <div class="capacity">${this.product.capacity}</div>

                          ${this.reviewsEnabled
                ? html `
                                    ${this.product.rating !== null
                    ? html `
                                              <div
                                                  itemprop="aggregateRating"
                                                  itemscope
                                                  itemtype="http://schema.org/AggregateRating"
                                              >
                                                  <meta itemprop="reviewCount" content="${this.product.rating.count}" />
                                                  <meta
                                                      itemprop="ratingValue"
                                                      content="${this.product.rating.average.toFixed(2)}"
                                                  />
                                              </div>
                                          `
                    : ''}
                                    <div class="rating">
                                        ${this.product.rating !== null
                    ? html `
                                                  ${Array.from(Array(Math.round(this.product.rating.average))).map(() => html ` <img src="/img/star_on.svg" title="star on" /> `)}
                                                  ${Array.from(Array(5 - Math.round(this.product.rating.average))).map(() => html ` <img src="/img/star_off.svg" title="star off" /> `)}
                                                  (${this.product.rating.count})
                                              `
                    : ''}
                                    </div>
                                `
                : ''}

                          <div class="price-container">
                              ${this.product.flags.green_point ? html ` <div class="green-point"></div> ` : ''}
                              <div class="price" itemprop="offers" itemscope itemtype="http://schema.org/Offer">
                                  <meta itemprop="priceCurrency" content="${this.currencyISO}" />
                                  <meta itemprop="sku" content="${this.sku ?? ''}" />
                                  <div>
                                      ${this.product.catalog_price !== this.product.price
                ? html `
                                                <meta
                                                    itemprop="price"
                                                    content="${this.product.price.toFixed(this.decimalDigits)}"
                                                />
                                                <meta
                                                    itemprop="oldPrice"
                                                    content="${this.product.catalog_price.toFixed(this.decimalDigits)}>"
                                                />
                                                <span>
                                                    ${this.product.price.toFixed(this.decimalDigits)}
                                                    <span>${this.currency}</span>
                                                </span>
                                                <div>
                                                    <del>
                                                        ${this.product.catalog_price.toFixed(this.decimalDigits)}
                                                        <span>${this.currency}</span>
                                                    </del>
                                                </div>
                                            `
                : html `
                                                <meta
                                                    itemprop="price"
                                                    content="${this.product.price.toFixed(this.decimalDigits)}"
                                                />
                                                <span>
                                                    ${this.product.price.toFixed(this.decimalDigits)}
                                                    <span>${this.currency}</span>
                                                </span>
                                            `}
                                  </div>
                                  ${this.product.availability.can_be_bought
                ? html ` <link itemprop="availability" href="http://schema.org/InStock" /> `
                : html ` <link itemprop="availability" href="http://schema.org/OutOfStock" /> `}
                              </div>
                              ${discountPercentage > 0
                ? html `
                                        <div class="discount">
                                            <span>${discountPercentage < 0 ? '+' : '-'}${discountPercentage}%</span>
                                        </div>
                                    `
                : ''}
                          </div>

                          ${this.product.lowest_price_from_30d !== null
                ? html `
                                    <div class="omnibus">
                                        ${i18n('Previous price {price} ({percent})')
                    .replace('{price}', `${this.product.lowest_price_from_30d.toFixed(this.decimalDigits)} ${this.currency}`)
                    .replace('{percent}', this.omnibusPercentage(this.product.lowest_price_from_30d, this.product.price))}
                                    </div>
                                `
                : ''}

                          <div class="unit-price">
                              ${this.product.price_per_unit !== null
                ? html `
                                        ${this.product.price_per_unit.unit}:
                                        ${this.product.price_per_unit.price.toFixed(this.decimalDigits)}
                                        ${this.currency}
                                    `
                : ''}
                          </div>

                          ${typeof this.product.attributes !== 'undefined' &&
                this.product.attributes.length > 0 &&
                !this.colorAsProduct
                ? html `
                                    <a
                                        class="select-color"
                                        productID="${this.product.id}"
                                        sku="${this.sku ?? ''}"
                                        @click=${(e) => {
                    e.preventDefault();
                    this.openColorSelection();
                }}
                                    >
                                        ${i18n('Select color')} (${this.product.attributes.length})
                                    </a>
                                    <a
                                        class="select-color prod-as-gift ${this.productAsGiftButtonText ? 'show' : ''}"
                                        productID="${this.product.id}"
                                        sku="${this.sku ?? ''}"
                                        @click=${(e) => {
                    e.preventDefault();
                    this.openColorSelection();
                }}
                                    >
                                        ${this.productAsGiftButtonText}
                                    </a>
                                `
                : html `
                                    ${this.activeStore
                    ? html `
                                              ${this.product.availability.can_be_bought
                        ? html `
                                                        <cart-add
                                                            sku="${this.sku ?? ''}"
                                                            productID="${this.product.id}"
                                                            altshopID="${this.altshopID}"
                                                        >
                                                            ${i18n('Add to cart')}
                                                        </cart-add>
                                                        <cart-add
                                                            class="prod-as-gift ${this.productAsGiftButtonText
                            ? 'show'
                            : ''}"
                                                            productAsGift
                                                            sku="${this.sku ?? ''}"
                                                            productID="${this.product.id}"
                                                            altshopID="${this.altshopID}"
                                                        >
                                                            ${this.productAsGiftButtonText}
                                                        </cart-add>
                                                    `
                        : html `
                                                        <div class="unavailable">${i18n('product unavailable')}</div>
                                                    `}
                                          `
                    : ''}
                                `}
                      </div>
                  `
            : ''}
        `;
    }
    openColorSelection() {
        if (this.product === null) {
            return;
        }
        openModal(`
            <div class="header close-only">
                <button class="close" data-micromodal-close></button>
            </div>
            <div class="content">
                <product-modal sku="${this.sku ?? ''}" productID="${this.product.id}" altshopID="${this.altshopID}"></product-modal>
            </div>
        `);
    }
    checkPromotions() {
        if (this.product === null) {
            return;
        }
        Cart.getPromotionForSKU(this.sku ?? '')
            .then((promotions) => {
            let found = false;
            promotions.forEach((promotion) => {
                promotion.actions.forEach((action) => {
                    if (action.type === 'product_as_gift') {
                        this.productAsGiftButtonText = action.settings.button_text;
                        found = true;
                    }
                });
            });
            if (!found) {
                this.productAsGiftButtonText = null;
            }
        })
            .catch((err) => {
            console.error('Failed to get promotions to check if product_as_gift is active ', err);
        });
    }
    getImageUrl(product, requestedSize) {
        let path = '/img/ts.gif';
        product.main_image.sizes.forEach((size) => {
            if (size.size === requestedSize) {
                path = size.url;
            }
        });
        return path;
    }
    get sku() {
        if (this.product === null) {
            return null;
        }
        if (this.colorAsProduct && typeof this.product.variant_sku !== 'undefined') {
            return this.product.variant_sku;
        }
        return this.product.sku;
    }
    omnibusPercentage(previousPrice, price) {
        const percent = Math.ceil(100 - (Number(price) / previousPrice) * 100);
        let percentString = '';
        if (Math.abs(percent) > 0) {
            if (percent < 0) {
                percentString = '+' + Math.abs(percent) + '%';
            }
            else {
                percentString = '-' + Math.abs(percent) + '%';
            }
        }
        return percentString;
    }
    get activeColorName() {
        if (this.product === null || typeof this.product.attributes === 'undefined') {
            return '';
        }
        let name = '';
        this.product.attributes.forEach((attr) => {
            if (this.product !== null &&
                typeof this.product.variant_sku !== 'undefined' &&
                attr.sku === this.product.variant_sku) {
                name = attr.attribute_name;
            }
        });
        return name;
    }
    get currency() {
        if (typeof window.__STATE__ === 'undefined') {
            return '';
        }
        return window.__STATE__.localization.currency;
    }
    get currencyISO() {
        if (typeof window.__STATE__ === 'undefined') {
            return '';
        }
        return window.__STATE__.localization.currency_iso;
    }
    get decimalDigits() {
        if (typeof window.__STATE__ === 'undefined') {
            return 2;
        }
        return window.__STATE__.localization.decimal_digits;
    }
    get wishlistEnabled() {
        if (typeof window.__STATE__ === 'undefined') {
            return false;
        }
        return window.__STATE__.functions.wishlist;
    }
    get reviewsEnabled() {
        if (typeof window.__STATE__ === 'undefined') {
            return false;
        }
        return window.__STATE__.functions.reviews;
    }
    get activeStore() {
        if (typeof window.__STATE__ === 'undefined') {
            return false;
        }
        return window.__STATE__.functions.active_store;
    }
};
__decorate([
    property({ type: Object })
], ProductTile.prototype, "product", void 0);
__decorate([
    property({ type: Boolean })
], ProductTile.prototype, "colorAsProduct", void 0);
__decorate([
    property({ type: Boolean })
], ProductTile.prototype, "stickersDisabled", void 0);
__decorate([
    property({ type: String })
], ProductTile.prototype, "productAsGiftButtonText", void 0);
__decorate([
    property({ type: String })
], ProductTile.prototype, "altshopID", void 0);
ProductTile = __decorate([
    customElement('product-tile')
], ProductTile);
export default ProductTile;
